import stops from '~/assets/json/stops.json'

export default defineNuxtRouteMiddleware((to) => {
  // skip middleware on server
  if (import.meta.server) return
  const path = to?.fullPath
  const isToBeRedirected = path?.includes('/schedule.aspx')

  if (isToBeRedirected) {
    const key = path
      .replace('/schedule.aspx?key=', '')
      .replace('/schedule.aspx?id=', '')

    const stop = stops.find((stop) => {
      const keyToMatch = stop.stopDiva * 100 + stop.stopPointDiva
      return keyToMatch === parseInt(key)
    })

    if (stop) {
      return navigateTo({
        path: `/stops/${stop.id}`,
      })
    } else {
      return navigateTo('/', {
        redirectCode: 301,
      })
    }
  }
})
